import{L as e,s as t,c as r,i as s,a as n,h as i}from"../id-0235c3a7.js";var o=({css:e})=>new Function("css","return css`:root,.alchemy-spinner{display:inline-flex;--spinner-color: var(--spinner-primary-color, var(--color-base-action, #06c))}.alchemy-spinner{display:inline-flex;flex-direction:column;align-items:center}.alchemy-spinner.top{flex-direction:column-reverse}.alchemy-spinner.end{flex-direction:row}.alchemy-spinner.bottom{flex-direction:column}.alchemy-spinner.start{flex-direction:row-reverse}.spinner{animation:1.6s spin linear infinite;color:var(--spinner-color)}.circle{stroke-dasharray:170;stroke-dashoffset:0;transform-origin:center;animation:dashRotate 2s ease-in-out infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes dashRotate{0%{stroke-dashoffset:170}50%{stroke-dashoffset:42.5;transform:rotate(180deg)}to{stroke-dashoffset:170;transform:rotate(1turn)}}\n`;")(e),a={id:{type:String},labelPosition:{attribute:"label-position",type:String},label:{type:String},labelSrOnly:{attribute:"label-sr-only",type:Boolean},size:{type:String},rtl:{type:Boolean}};class l extends e{static get styles(){return[t({css:r}),o({css:r})]}static get properties(){return a}constructor(){super(),this.id=s(),this.labelSrOnly=!1,this.label="",this.size=1.25,this.rtl="rtl"==getComputedStyle(document.documentElement).direction}render(){const{id:e,label:t,labelPosition:r,rtl:s,size:o}=this,a=n({"alchemy-spinner":!0,[r]:r,rtl:s}),l=n({spinner:!0}),c=n({"sr-only":this.labelSrOnly}),p={sm:1,lg:1.5,xl:1.5,xxl:1.75};let d=o;return isNaN(o)?"string"==typeof o&&""!==o&&void 0!==p[o]&&(d=p[o]):d=Number(o),i`
			<span id="${e}" class="${a}">
				<svg
					class="${l}"
					style="width: ${d}rem; height: ${d}rem;"
					viewBox="0 0 100 100"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
				>
					<circle
						class="circle"
						fill="none"
						stroke="currentColor"
						stroke-width="10"
						stroke-linecap="square"
						stroke-dasharray="180"
						stroke-dashoffset="90"
						cx="50"
						cy="50"
						r="30"
					></circle>
				</svg>

				<span class="${c}">${t}</span>
			</span>
		`}}window.customElements.define("alchemy-spinner",l);export{l as Spinner};
